import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentsComponent } from './components/payments/payments.component';
import { StripeComponent } from './components/payments/stripe/stripe.component';
import { BraintreeComponent } from './components/payments/braintree/braintree.component';
import { InputModule } from '@serviceos-ng/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputFormatterDirective } from './directives/input-formatter.directive';
import { ScriptLoaderModule } from 'ngx-script-loader';



@NgModule({
  declarations: [
    PaymentsComponent,
    StripeComponent,
    BraintreeComponent,
    InputFormatterDirective
  ],
  imports: [
    CommonModule,
    InputModule,
    ReactiveFormsModule,
    ScriptLoaderModule
  ],
  exports: [
    PaymentsComponent,
    StripeComponent,
    BraintreeComponent,
    InputFormatterDirective
  ]
})
export class PaymentsModule { }
